module.exports = __webpack_public_path__ + "img/Cloudwatch.8039a530.png";